var sideStroke = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/sideStroke.jpg';
var sideStrokeDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/sideStrokeDetail1.jpg';
var twistShout = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/twistShout.jpg';
var rescue = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/rescue.jpg';
var tubes = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/tubes.jpg';
var tubesDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/tubesDetail1.jpg';
var chickenFight = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/chickenFight.jpg';
var chickenFightDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/chickenFightDetail1.jpg';
var chase = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-pp/chase.jpg';

export const allImagesDesktopOrderPp = [
    [/*COLUMN 1*/
        [
            {
                name: sideStroke,
                artistName: "Lorraine Shemesh",
                title: "Side-Stroke",
                year: "1994",
                dimensions: "67 1/2 x 81 in., o/c",
                link: "pp1",
                privateCollection: "Private Collection"
            },
            {
                name: sideStrokeDetail1,
                artistName: "Lorraine Shemesh",
                title: "Side-Stroke - detail",
                year: "1994",
                dimensions: "67 1/2 x 81 in., o/c",
                link: "pp2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: twistShout,
                artistName: "Lorraine Shemesh",
                title: "Twist and Shout",
                year: "1993",
                dimensions: "78 x 71 in., o/c",
                link: "pp3",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: rescue,
                artistName: "Lorraine Shemesh",
                title: "Rescue",
                year: "1994",
                dimensions: "68 1/2 x 84 in., o/c",
                link: "pp4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: tubes,
                artistName: "Lorraine Shemesh",
                title: "Tubes",
                year: "1993",
                dimensions: "77 1/2 x 66 1/2 in., o/c",
                link: "pp5",
                privateCollection: "Private Collection"
            },
            {
                name: tubesDetail1,
                artistName: "Lorraine Shemesh",
                title: "Tubes - detail",
                year: "1993",
                dimensions: "77 1/2 x 66 1/2 in., o/c",
                link: "pp6",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: chickenFight,
                artistName: "Lorraine Shemesh",
                title: "Chicken Fight",
                year: "1992",
                dimensions: "68 x 84 in., o/c",
                link: "pp7",
                privateCollection: "Private Collection"
            },
            {
                name: chickenFightDetail1,
                artistName: "Lorraine Shemesh",
                title: "Chicken Fight - detail",
                year: "1992",
                dimensions: "68 x 84 in., o/c",
                link: "pp8",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: chase,
                artistName: "Lorraine Shemesh",
                title: "Chase",
                year: "1992",
                dimensions: "70 x 75 in., o/c",
                link: "pp9",
                privateCollection: "Private Collection"
            }
        ]
    ]          
]

export const allImagesMobileOrderPp = [
    [{
        name: sideStroke,
        artistName: "Lorraine Shemesh",
        title: "Side-Stroke",
        year: "1994",
        dimensions: "67 1/2 x 81 in., o/c",
        link: "pp1",
        privateCollection: "Private Collection"
    },
    {
        name: sideStrokeDetail1,
        artistName: "Lorraine Shemesh",
        title: "Side-Stroke - detail",
        year: "1994",
        dimensions: "67 1/2 x 81 in., o/c",
        link: "pp2",
        privateCollection: "Private Collection"
    },
    {
        name: twistShout,
        artistName: "Lorraine Shemesh",
        title: "Twist and Shout",
        year: "1993",
        dimensions: "78 x 71 in., o/c",
        link: "pp3",
        privateCollection: "Private Collection"
    },
    {    
        name: rescue,
        artistName: "Lorraine Shemesh",
        title: "Rescue",
        year: "1994",
        dimensions: "68 1/2 x 84 in., o/c",
        link: "pp4",
        privateCollection: "Private Collection"
    },
    {
        name: tubes,
        artistName: "Lorraine Shemesh",
        title: "Tubes",
        year: "1993",
        dimensions: "77 1/2 x 66 1/2 in., o/c",
        link: "pp5",
        privateCollection: "Private Collection"
    },
    {
        name: tubesDetail1,
        artistName: "Lorraine Shemesh",
        title: "Tubes - detail",
        year: "1993",
        dimensions: "77 1/2 x 66 1/2 in., o/c",
        link: "pp6",
        privateCollection: "Private Collection"
    },
    {
        name: chickenFight,
        artistName: "Lorraine Shemesh",
        title: "Chicken Fight",
        year: "1992",
        dimensions: "68 x 84 in., o/c",
        link: "pp7",
        privateCollection: "Private Collection"
    },
    {
        name: chickenFightDetail1,
        artistName: "Lorraine Shemesh",
        title: "Chicken Fight - detail",
        year: "1992",
        dimensions: "68 x 84 in., o/c",
        link: "pp8",
        privateCollection: "Private Collection"
    },
    {
        name: chase,
        artistName: "Lorraine Shemesh",
        title: "Chase",
        year: "1992",
        dimensions: "70 x 75 in., o/c",
        link: "pp9",
        privateCollection: "Private Collection"
    }]      
]
